module.exports = __webpack_public_path__ + "static/media/xls.21969610.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/xls.svg
// module id = 1675
// module chunks = 17